export const APPROVE_RADIO_VALUE = {
  APPROVE: true,
  NOT_APPROVE: false,
};

export const CHECK_BOX_VALUE = {
  APPROVE: true,
  NOT_APPROVE: false,
};

export const USB_TOKEN_URL = "ws://localhost:41803";
// export const USB_TOKEN_URL = "ws://192.168.118.196:41803";

export const REGISTRY_INVOICE_FIELD = {
  COMMON: {
    PBAN: {
      field: "pban",
      type: "text",
      max: 6,
    },
    MSO: {
      field: "mso",
      type: "text",
      max: 15,
    },
    TEN: {
      field: "ten",
      type: "text",
      max: 100,
    },
    HTHUC: {
      field: "hthuc",
      type: "select",
      selectValues: {
        ADD: 1,
        EDIT: 2,
      },
      max: 1,
    },
    TNNT: {
      field: "tnnt",
      type: "text",
      max: 400,
    },
    MST: {
      field: "mst",
      type: "text",
      max: 14,
    },
    CQTQLY: {
      field: "cqtqly",
      type: "select",
      max: 100,
    },
    MCQTQLY: {
      field: "mcqtqly",
      type: "text",
      max: 5,
    },
    NLHE: {
      field: "nlhe",
      type: "text",
      max: 50,
    },
    DCLHE: {
      field: "dclhe",
      type: "text",
      max: 400,
    },
    DCTDTU: {
      field: "dctdtu",
      type: "text",
      max: 50,
    },
    DTLHE: {
      field: "dtlhe",
      type: "text",
      max: 20,
    },
    DDANH: {
      field: "ddanh",
      type: "text",
      max: 20,
    },
    NLAP: {
      field: "nlap",
      type: "date",
    },
    //Tên người đại diện pháp luật
    TNDDPLuat: {
      field: "tnddpluat",
      type: "text",
      max: 50,
    },
    // Điện thoại người đại diện pháp luật
    DTDDPLuat: {
      field: "dtddpluat",
      type: "text",
      max: 20,
    },
    // Căn cước công dân
    CCCDan: {
      field: "cccdan",
      type: "text",
      max: 12,
    },
    // Số hộ chiếu
    SHChieu: {
      field: "shchieu",
      type: "text",
      max: 20,
    },
    // Ngày sinh đại diện pháp luật
    NSDDPL: {
      field: "nsddpl",
      type: "date",
    },
    // Giới tính
    GTinh: {
      field: "gtinh",
      type: "radioField",
      max: 1,
    },
  },
  INFO_DETAIL: {
    // Cơ quan xử lý tài sản công
    CQXLTSCong: {
      field: "cqxltscong",
      type: "radioField",
      max: 1,
    },
    // Hóa đơn GTGT thay thế, bồi lái
    HDGTGTTHBLai: {
      field: "hdgtgtthblai",
      type: "checkbox",
      checkboxValues: {
        APPROVE: 1,
        NOT_APPROVE: 0,
      },
    },
    // Hóa đơn bán hàng thay thế, bồi lái
    HDBHTHBLai: {
      field: "hdbhthblai",
      type: "checkbox",
      checkboxValues: {
        APPROVE: 1,
        NOT_APPROVE: 0,
      },
    },
    // Hóa đơn tem, mác
    HDTMai: {
      field: "hdtmai",
      type: "checkbox",
      checkboxValues: {
        APPROVE: 1,
        NOT_APPROVE: 0,
      },
    },
    CMA: {
      field: "cma",
      type: "radio",
      radioValues: {
        APPROVE: 1,
        NOT_APPROVE: 0,
      },
      max: 1,
    },
    KCMA: {
      field: "kcma",
      type: "radio",
      radioValues: {
        APPROVE: 1,
        NOT_APPROVE: 0,
      },
      max: 1,
    },
    NNTDBKKHAN: {
      field: "nntdbkkhan",
      type: "radio",
      radioValues: {
        APPROVE: 1,
        NOT_APPROVE: 0,
      },
      max: 1,
    },
    NNTKTDNUBND: {
      field: "nntktdnubnd",
      type: "radio",
      radioValues: {
        APPROVE: 1,
        NOT_APPROVE: 0,
      },
      max: 1,
    },
    CDLTTDCQT: {
      field: "cdlttdcqt",
      type: "radio",
      radioValues: {
        APPROVE: 1,
        NOT_APPROVE: 0,
      },
      max: 1,
    },
    CDLQTCTN: {
      field: "cdlqtctn",
      type: "radio",
      radioValues: {
        APPROVE: 1,
        NOT_APPROVE: 0,
      },
      max: 1,
    },
    CDDU: {
      field: "cddu",
      type: "radio",
      radioValues: {
        APPROVE: 1,
        NOT_APPROVE: 0,
      },
      max: 1,
    },
    CBTHOP: {
      field: "cbthop",
      type: "radio",
      radioValues: {
        APPROVE: 1,
        NOT_APPROVE: 0,
      },
      max: 1,
    },
    HDGTGT: {
      field: "hdgtgt",
      type: "checkbox",
      checkboxValues: {
        APPROVE: 1,
        NOT_APPROVE: 0,
      },
    },
    HDBHANG: {
      field: "hdbhang",
      type: "checkbox",
      checkboxValues: {
        APPROVE: 1,
        NOT_APPROVE: 0,
      },
    },
    HDBTSCONG: {
      field: "hdbtscong",
      type: "checkbox",
      checkboxValues: {
        APPROVE: 1,
        NOT_APPROVE: 0,
      },
    },
    HDBHDTQGIA: {
      field: "hdbhdtqgia",
      type: "checkbox",
      checkboxValues: {
        APPROVE: 1,
        NOT_APPROVE: 0,
      },
    },
    HDKHAC: {
      field: "hdkhac",
      type: "checkbox",
      checkboxValues: {
        APPROVE: 1,
        NOT_APPROVE: 0,
      },
    },
    CTU: {
      field: "ctu",
      type: "checkbox",
      checkboxValues: {
        APPROVE: 1,
        NOT_APPROVE: 0,
      },
    },
    CMTMTTIEN: {
      field: "cmtmttien",
      type: "checkbox",
      checkboxValues: {
        APPROVE: 1,
        NOT_APPROVE: 0,
      },
    },
  },
  LIST_CA: {
    field: "listCAs",
    STT: {
      field: "stt",
      type: "number",
      isHide: true,
    },
    TTCHUC: {
      field: "ttchuc",
      type: "text",
      required: true,
      max: 400,
    },
    SERI: {
      field: "seri",
      required: true,
      type: "text",
      max: 40,
    },
    TNGAY: {
      field: "tngay",
      required: true,
      width: "300px",
      type: "date",
    },
    DNGAY: {
      field: "dngay",
      required: true,
      type: "date",
    },
    HTHUC: {
      field: "hthuc",
      required: true,
      type: "select",
      max: 1,
      selectValues: {
        ADD: 1, // thêm mới
        EXTEND: 2, // gia hạn
        STOP_USE: 3, //ngừng sử dụng
      },
    },
  },
  TTTCGP: {
    field: "listTCGPs",
    STT: {
      field: "stt",
      type: "number",
      isHide: true,
    },
    TTCGP: {
      field: "ttcgp",
      type: "text",
      required: true,
      max: 400,
      isDisable: true,
    },
    MSTTCGP: {
      field: "msttcgp",
      type: "text",
      required: true,
      max: 14,
      isTaxCode: true,
      isDisable: true,
    },
    TNGAY: {
      field: "tngay",
      required: true,
      width: "300px",
      type: "date",
    },
    DNGAY: {
      field: "dngay",
      required: false,
    },
    GCHU: {
      field: "gchu",
      type: "text",
      required: false,
      max: 255,
    },
  },
  TTTCTN: {
    field: "listTCTNs",
    STT: {
      field: "stt",
      type: "number",
      isHide: true,
    },
    TTCTN: {
      field: "ttctn",
      type: "text",
      required: true,
      max: 400,
      isDisable: true,
    },
    MSTTCTN: {
      field: "msttctn",
      type: "text",
      required: true,
      max: 14,
      isTaxCode: true,
      isDisable: true,
    },
    TNGAY: {
      field: "tngay",
      required: true,
      width: "300px",
      type: "date",
    },
    DNGAY: {
      field: "dngay",
      required: false,
    },
    GCHU: {
      field: "gchu",
      type: "text",
      required: false,
      max: 255,
    },
  },
  TTDVHTPT: {
    field: "listDVHTPTs",
    STT: {
      field: "stt",
      type: "number",
      isHide: true,
    },
    TDVHTPT: {
      field: "tdvhtpt",
      type: "text",
      required: true,
      max: 400,
    },
    MSTDVHTPT: {
      field: "mstdvhtpt",
      type: "text",
      required: true,
      max: 14,
      isTaxCode: true,
    },
    TNGAY: {
      field: "tngay",
      required: true,
      width: "300px",
      type: "date",
    },
    DNGAY: {
      field: "dngay",
      required: false,
      // type: "date",
    },
    GCHU: {
      field: "gchu",
      type: "text",
      required: false,
      max: 255,
    },
  },
  TTTNSDung: {
    field: "listTNSDungs",
    STT: {
      field: "stt",
      type: "number",
      isHide: true,
    },

    TTCGP: {
      field: "ttcgp",
      type: "text",
      required: true,
      max: 400,
    },
    MSTTCGP: {
      field: "msttcgp",
      type: "text",
      required: true,
      max: 14,
      isTaxCode: true,
    },
    TNGAY: {
      field: "tngay",
      required: true,
      width: "300px",
      type: "date",
    },
    DNGAY: {
      field: "dngay",
      required: true,
    },
    SERI: {
      field: "seri",
      type: "text",
      required: false,
      max: 40,
    },
    GCHU: {
      field: "gchu",
      type: "text",
      required: false,
      max: 255,
    },
  },
  TTDKTH: {
    field: "listDKTHs",
    STT: {
      field: "stt",
      type: "number",
      isHide: true,
    },
    TLHDON: {
      field: "tlhdon",
      type: "text",
      required: true,
      max: 100,
    },
    KHMSHDON: {
      field: "khmshdon",
      type: "select",
      selectValues: {
        KHMSHDON_1: 1, // Phụ lục 2
        KHMSHDON_2: 2, // Phụ lục 2
        KHMSHDON_3: 3, // Phụ lục 2
        KHMSHDON_4: 4, // Phụ lục 2
        KHMSHDON_5: 5, // Phụ lục 2
        KHMSHDON_6: 6, // Phụ lục 2
      },
      required: true,
    },
    KHHDON: {
      field: "khhdon",
      type: "text",
      required: true,
      max: 50,
    },
    TEN: {
      field: "ten",
      type: "text",
      required: true,
      max: 400,
    },
    MST: {
      field: "mst",
      type: "text",
      required: true,
      max: 14,
      isTaxCode: true,
    },
    MDICH: {
      field: "mdich",
      type: "text",
      required: true,
      max: 255,
    },
    TNGAY: {
      field: "tngay",
      required: true,
      width: "300px",
      type: "date",
    },
    DNGAY: {
      field: "dngay",
      required: true,
    },
    GCHU: {
      field: "gchu",
      type: "text",
      required: false,
      max: 255,
    },
  },
};

export const REGISTRY_DELEGATE_FIELD = {
  COMMON: {
    PBAN: {
      field: "pban",
      type: "text",
      max: 6,
    },
    MSO: {
      field: "mso",
      type: "text",
      max: 15,
    },
    TEN: {
      field: "ten",
      type: "text",
      max: 100,
    },
    LDKUNHIEM: {
      field: "ldkunhiem",
      type: "select",
      selectValues: {
        DELEGATE: 1, // ủy nhiệm
        GET_MANDATE: 2, // nhận ủy nhiệm
      },
    },
    TNNT: {
      field: "tnnt",
      type: "text",
      max: 400,
    },
    MST: {
      field: "mst",
      type: "text",
      max: 14,
    },
    CQTQLY: {
      field: "cqtqly",
      type: "text",
      max: 100,
    },
    MCQTQLY: {
      field: "mcqtqly",
      type: "text",
      max: 5,
    },
    NLHE: {
      field: "nlhe",
      type: "text",
      max: 50,
    },
    DCLHE: {
      field: "dclhe",
      type: "text",
      max: 400,
    },
    DCTDTU: {
      field: "dctdtu",
      type: "text",
      max: 50,
    },
    DTLHE: {
      field: "dtlhe",
      type: "text",
      max: 20,
    },
    DDANH: {
      field: "ddanh",
      type: "text",
      max: 20,
    },
    NLAP: {
      field: "nlap",
      type: "date",
    },
  },
  LIST_CAS: {
    field: "listRegistryDelegateCas",
    STT: {
      field: "stt",
      type: "number",
      isHide: true,
    },
    TTCHUC: {
      field: "ttchuc",
      type: "text",
      max: 400,
    },
    SERI: {
      field: "seri",
      type: "text",
      max: 40,
    },
    TNGAY: {
      field: "tngay",
      width: "280px",
      type: "date",
      required: true,
    },
    DNGAY: {
      field: "dngay",
      type: "date",
    },
    HTHUC: {
      field: "hthuc",
      type: "select",
      max: 1,
      selectValues: {
        ADD: 1, // thêm mới
        EXTEND: 2, // gia hạn
        STOP_USE: 3, //ngừng sử dụng
      },
    },
  },
  LIST_INVOICES: {
    field: "listRegistryDelegateInvoices",
    STT: {
      field: "stt",
      type: "number",
      isHide: true,
    },
    TLHDON: {
      field: "tlhdon",
      type: "text",
      max: 100,
    },
    KHMSHDON: {
      field: "khmshdon",
      type: "select",
      selectValues: {
        KHMSHDON_1: 1, // Phụ lục 2
        KHMSHDON_2: 2, // Phụ lục 2
        KHMSHDON_3: 3, // Phụ lục 2
        KHMSHDON_4: 4, // Phụ lục 2
        KHMSHDON_5: 5, // Phụ lục 2
        KHMSHDON_6: 6, // Phụ lục 2
      },
      max: 9,
    },
    KHHDON: {
      field: "khhdon",
      type: "text",
      max: 6,
    },
    MST: {
      field: "mst",
      type: "text",
      max: 14,
      isTaxCode: true,
    },
    TTCHUC: {
      field: "ttchuc",
      type: "text",
      max: 400,
    },
    MDICH: {
      field: "mdich",
      type: "text",
      max: 255,
    },
    TNGAY: {
      field: "tngay",
      width: "280px",
      type: "date",
      required: true,
    },
    DNGAY: {
      field: "dngay",
      type: "date",
    },
    PTHUC: {
      field: "pthuc",
      type: "text",
      max: 50,
    },
  },
};

export const REQUEST_INVOICE_CODE_FIELD = {
  COMMON: {
    PBAN: {
      field: "pban",
      type: "text",
      max: 6,
    },
    MSO: {
      field: "mso",
      type: "text",
      max: 15,
    },
    TEN: {
      field: "ten",
      type: "text",
      max: 100,
    },
    TCQT: {
      field: "tcqt",
      type: "text",
      max: 100,
    },
    MCQT: {
      field: "mcqt",
      type: "text",
      max: 5,
    },
    TTCCNHAN: {
      field: "ttccnhan",
      type: "text",
      max: 400,
    },
    DCLHE: {
      field: "dclhe",
      type: "text",
      max: 400,
    },
    DCTDTU: {
      field: "dctdtu",
      type: "text",
      max: 50,
    },
    DTLHE: {
      field: "dtlhe",
      type: "text",
      max: 20,
    },
    SQDTLAP: {
      field: "sqdtlap",
      type: "text",
      max: 50,
    },
    NCQDTLAP: {
      field: "ncqdtlap",
      type: "date",
    },
    CQCQDTLAP: {
      field: "cqcqdtlap",
      type: "text",
      max: 200,
    },
    MST: {
      field: "mst",
      type: "text",
      max: 14,
    },
    TNNHDON: {
      field: "tnnhdon",
      type: "text",
      max: 100,
    },
    CMND: {
      field: "cmnd",
      type: "text",
      max: 20,
    },
    NGCCMND: {
      field: "ngccmnd",
      type: "date",
    },
    NCCMND: {
      field: "nccmnd",
      type: "text",
      max: 100,
    },
    DDANH: {
      field: "ddanh",
      type: "text",
      max: 20,
    },
    NLAP: {
      field: "nlap",
      type: "date",
    },
  },
  REQUEST_CONTENT_OBJ: {
    field: "requestContentObj",
    THHDVU: {
      field: "thhdvu",
      type: "text",
      max: 500,
    },
    TEN: {
      field: "ten",
      type: "text",
      max: 400,
    },
    DCHI: {
      field: "dchi",
      type: "text",
      max: 400,
    },
    MST: {
      field: "mst",
      type: "text",
      max: 14,
    },
    SHDONG: {
      field: "shdong",
      type: "text",
      max: 50,
    },
    NHDONG: {
      field: "nhdong",
      type: "date",
    },
    DTPSINHNM: {
      field: "dtpsinhnm",
      type: "number",
      max: 21.6,
    },
  },
};

export const AUTH_STATUS_NEW = "M"; //"Lưu tạm",
export const AUTH_STATUS_PROGRESSING = "P"; //"Chờ phát hành",
export const AUTH_STATUS_WAITING = "H"; //"Chờ phát hành",
export const AUTH_STATUS_REJECT = "R"; //"Từ chối phát hành",
export const AUTH_STATUS_APPROVE = "A"; //"Đã phát hành",

export const AUTH_STATUS_RR = "RR"; //"Từ chối tiếp nhận đăng ký",
export const AUTH_STATUS_RRE = "RRE"; //"Từ chối tiếp nhận thay đổi"

export const AUTH_STATUS_AR = "AR"; // Đã tiếp nhận đăng ký
export const AUTH_STATUS_ARE = "ARE"; // Đã tiếp nhận thay đổi

export const AUTH_STATUS_REPLACE = "S"; //"Thay thế",
export const AUTH_STATUS_EDIT = "E"; //"Điều chỉnh",
export const AUTH_STATUS_CANCEL = "C"; //"Hủy",
export const AUTH_STATUS_CANCEL_WAITING = "CW"; //"Chờ hủy",
export const AUTH_STATUS_REJECT_CANCEL = "RC"; //"Từ chối hủy",

export const AUTH_STATUS_WARNING = "W";

export const APPROVE_STATUS_M = "M"; //"Lưu tạm",
export const APPROVE_STATUS_P = "P"; //"Gửi chờ duyệt",
export const APPROVE_STATUS_A = "A"; //"Đã duyệt",
export const APPROVE_STATUS_R = "R"; //"Từ chối duyệt",

export const CLIENT_TYPE_CONST = {
  SALE: "SALE", //HĐ GTGT bình thường
  SALE_ADJ: "SALE_ADJ", //HĐ GTGT Điều chỉnh giảm
  IBT_GTGT: "IBT_GTGT", //PXK trường hợp ngoại tỉnh
  GRA: "GRA", //HĐ GTGT Trả hàng cho NCC
  GRA_ADJ: "GRA_ADJ", //HĐ GTGT Trả hàng cho NCC điều chỉnh giảm

  IBT: "IBT", //phiếu xuất kho bình thường
  IBT_CSM: "IBT_CSM", //phiếu xuất kho có hàng consignment
};

export const TYPE_TRANSFER = {
  REGISTER: 1,
  INVOICE: 2,
  HDSS: 3, // Thông báo HD sai sót
  HDTH: 4, // bảng tổng hợp
  WAREHOUSES: 6, //Phiếu xuất kho
};

export const SOURCE_QUEUE = {
  QUEUE_MSEAG: "QUEUE_MSEAG", // Guradian
  QUEUE: "QUEUE",
  QUEUE_HQ: "QUEUE_HQ",
  DEFAULT: "DEFAULT",
};

export const generateYupSchemaTableField = ({
  fieldConstant,
  listConstant,
  t,
  yup,
}) => {
  const listFieldSchema = {};
  for (const key in listConstant) {
    const itemField = listConstant[key];
    const { field, type, max, required } = itemField;
    switch (type) {
      case "text":
        listFieldSchema[field] = yup
          .string()
          .nullable()
          .max(max, t("form.validate.char_max", { max: max }));
        if (required) {
          listFieldSchema[field] = listFieldSchema[field].required(
            t("form.validate.required", {
              title: t(`field.${fieldConstant}.${field}`),
            })
          );
        }
        break;
      case "date":
        listFieldSchema[field] = yup.array().nullable();
        if (required) {
          let min = 1;
          if (listConstant["DNGAY"]?.required) {
            min = 2;
          }
          listFieldSchema[field] = listFieldSchema[field].min(
            min,
            t("form.validate.required", {
              title: t(`field.${fieldConstant}.${itemField.field}`),
            })
          );
        }
        break;
      case "select":
        listFieldSchema[field] = yup.object().nullable();
        if (required) {
          listFieldSchema[field] = listFieldSchema[field].required(
            t("form.validate.required", {
              title: t(`field.${fieldConstant}.${itemField.field}`),
            })
          );
        }
        break;
    }
    if (itemField.isTaxCode) {
      listFieldSchema[field] = listFieldSchema[field].test(
        "len",
        "Vui lòng nhập 10 hoặc 14 ký tự",
        val => {
          return val.length === 0 || val.length === 10 || val.length === 14;
        }
      );
    }
  }
  // console.log(
  //   "🚀 ~ generateYupSchemaTableField ~ fieldConstant:",
  //   fieldConstant
  // );
  // console.log(
  //   "🚀 ~ generateYupSchemaTableField ~ listFieldSchema:",
  //   listFieldSchema
  // );
  return yup.object().shape(listFieldSchema);
};
